import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Map } from "immutable";
import { FormSection, Field } from "redux-form";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { validateForShippingType } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/validate";
import ShippingFields from "MODULES/Orders/shared/ShippingFields/ShippingFields";
import * as actions from "MODULES/SalesOrders/actions";
import {
  RETURN_TO,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";

export function Form(props) {
  const { salesOrder, hasExchange = false } = props;
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormSection name="">
          <h4>Return To</h4>
          <ShippingFields
            shipToCompany={salesOrder.toJS().return_to_company}
            key="return-to-shipping-fields"
            formName={"salesOrderReturnToDetails"}
            path={RETURN_TO}
            renderCarrier={!hasExchange}
            shippingFields={[
              RETURN_TO_TYPE,
              RETURN_TO_COMPANY_ID,
              RETURN_TO_COMPANY_ADDRESS_ID
            ]}
            shippingMethod={RETURN_TO_SHIPPING_METHOD}
            shippingTypes={[]}
            shippingAddressField={RETURN_TO_SHIPPING_ADDRESS}
            required={hasExchange}
            locationFieldName={RETURN_TO_LOCATION_ID}
          />
          <Field
            name="return_to_fob"
            component={FormInput}
            label="Return To FOB"
            required
          />
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  salesOrder: T.instanceOf(Map),
  hasExchange: T.bool
};

export default connect(undefined, {
  onSubmit: actions.update
})(
  withSalesOrder(
    form({
      form: "salesOrderReturnToDetails",
      validate: validateForShippingType("return_to")
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/ReturnTo/Form.jsx